import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { AuthorizationResponseDto } from '../dtos/authorization-response.dto';

/**
 * Auth API service.
 * Handles HTTP communication with authentication and authorization endpoints.
 */
@Injectable({ providedIn: 'root' })
export class AuthApi {
  private readonly http = inject(HttpClient);
  private readonly config = inject(AppConfigService);

  /**
   * Local development login endpoint.
   * Authenticates user by email only (no password required).
   * Only available in local development environment.
   * @param email - User email address
   * @returns Observable with JWT token
   */
  localLogin(email: string): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(`${this.config.apiBaseUrl}/local/login`, { email });
  }

  getCurrentUserAuthorization(context: string): Observable<AuthorizationResponseDto> {
    return this.http.get<AuthorizationResponseDto>(
      `${this.config.versionedApiUrl}/${context}/authorization/current`
    );
  }
}
